import React from "react";
import { LocationTable } from "./location-details-table/LocationTable";

export function LocationCard() {

  return (
      <LocationTable />
  );
}
